export default __webpack_public_path__ + "static/aegis-fce3e90dcbc1acdae8a0a5a6f725e4bd.png";